/**
 * 节点画布 · 非流式对话（POST /volc_chat stream:false）
 */

import { resolveApiUrl } from './apiBaseUrl'

function getToken() {
  if (typeof localStorage === 'undefined') return ''
  return localStorage.getItem('token') || sessionStorage.getItem('token') || ''
}

function unwrapPayload(res) {
  if (!res || typeof res !== 'object') return res
  if (res.data && typeof res.data === 'object' && Array.isArray(res.data.choices)) {
    return res.data
  }
  if (res.data && typeof res.data === 'object' && res.data.data && Array.isArray(res.data.data.choices)) {
    return res.data.data
  }
  return res
}

function extractMessageText(body) {
  const u = unwrapPayload(body)
  const c = u?.choices?.[0]?.message?.content
  if (typeof c === 'string' && c.trim()) return c.trim()
  if (typeof u?.choices?.[0]?.text === 'string') return u.choices[0].text.trim()
  try {
    return JSON.stringify(u).slice(0, 1200)
  } catch {
    return ''
  }
}

/**
 * @param {{ messages: Array, model?: string, baseUrl?: string, signal?: AbortSignal }} opts
 * baseUrl 例如 https://api.deepseek.com，与后端 resolveChatBaseUrl 一致；不传则走后台默认（方舟或 DeepSeek 配置）
 */
export async function volcChatComplete(opts) {
  const messages = opts && Array.isArray(opts.messages) ? opts.messages : []
  const model =
    (opts && opts.model != null && String(opts.model).trim()) || 'deepseek-v4-flash'

  const payload = {
    model,
    messages,
    stream: false
  }
  const bu = opts && opts.baseUrl != null ? String(opts.baseUrl).trim() : ''
  if (bu) {
    payload.base_url = bu
  }

  const res = await fetch(resolveApiUrl('/volc_chat'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: getToken()
    },
    body: JSON.stringify(payload),
    signal: opts && opts.signal
  })
  const text = await res.text()
  let data
  try {
    data = JSON.parse(text)
  } catch {
    data = { raw: text }
  }
  if (!res.ok) {
    const msg =
      (data && (data.message || data.msg || data.error)) || text.slice(0, 400) || `HTTP ${res.status}`
    throw new Error(typeof msg === 'string' ? msg : JSON.stringify(msg))
  }
  return extractMessageText(data)
}
